import { InjectionToken } from '@angular/core';
import { BrandConfig } from './brand-config';
import { BRAND_KFZDOKU } from './brand.kfzdoku';
import { BRAND_VEHLOGS } from './brand.vehlogs';

/**
 * Which brand this build shows. The brand follows the LANGUAGE (plan D40) – so the translation files decide:
 * the English text is 'vehlogs', the German translation in messages.de.xlf is 'kfzdoku'.
 * It is a technical value; the description in front of the ID tells a translator not to change it.
 */
const BRAND_ID_OF_THIS_LANGUAGE = $localize`:Technical value. Must be 'kfzdoku' in German and 'vehlogs' in every other language.@@brand_id_of_language:vehlogs`;

/** The brand of this build – for code that runs outside dependency injection (the cookie banner config). */
export function brandOfThisBuild(): BrandConfig {
  if (BRAND_ID_OF_THIS_LANGUAGE === 'kfzdoku') {
    return BRAND_KFZDOKU;
  }
  return BRAND_VEHLOGS;
}

/**
 * Inject this token wherever the code needs the brand:
 *   private readonly brand = inject(BRAND);
 */
export const BRAND = new InjectionToken<BrandConfig>('BRAND', {
  providedIn: 'root',
  factory: () => brandOfThisBuild(),
});